import {useMutation, useQueryClient} from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {toast} from "react-toastify";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";

export function useDeleteKBFile(folderId: string | undefined) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.DELETE_FILE],
        mutationFn: (id: string) => KnowledgeBaseAPI.deleteFile(id),
        onError() {
            toast.error("Ошибка удаления файла");
        },

        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES, folderId]});
            toast.success("Файл удалена");
        }
    });
}
